<panel width="400">
	<menu always-visible>
		<menuitem (click)="createTeam()">{{ 'general.create' | translate }}</menuitem>
	</menu>
	<h1>{{ 'team.teams-list' | translate }}</h1>
	<list-view [emptyLabel]="'team.teams-list.teams-list-empty-label'" scrollable>
		<header defaultSort="ascending">{{ 'team.teams-list.name' | translate }}</header>
		<header>{{ 'team.teams-list.sale' | translate }}</header>
		<header></header>
		<row *listData="let team from teams" [highlighted]="highlightedTeamId == team.id" (action)="displayTeam(team)">
			<column>{{ team.name }}</column>
			<column>{{ (team.sale ? 'general.true' : 'general.false') | translate }}</column>
			<column align-right><icon [ngClass]="{ 'disabled': !canDeleteTeam(team) }" (click)="$event.stopPropagation(); deleteTeam(team)" type="trash-alt" /></column>
		</row>
	</list-view>
</panel>
